import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

import { GroupPicker } from "@/modules/groups/components/GroupPicker/GroupPicker";
import { Avatar } from "@/modules/theme/components/Avatar";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { useUserDataContext } from "@/modules/user/hooks/useUserDataContext";

import { AchievementData } from "../AchievementData/AchievementData";

import { createUserMenuStyles } from "./createUserMenuStyles";

const translationNamespace = "layouts/AuthenticatedLayout/components/UserMenu";

export const UserMenu = () => {
  const classes = createUserMenuStyles(useTheme());
  const { t } = useTranslation(translationNamespace);
  const {
    isUserDataFetching,
    userDataQueryStatus,
    userDetails,
    currentGroup,
    currentAchievements,
    changeGroup,
  } = useUserDataContext();

  const isUserDataLoading = userDataQueryStatus === "loading";

  if (
    !isUserDataLoading &&
    !userDetails?.firstName &&
    !userDetails?.lastName &&
    !currentGroup
  ) {
    return null;
  }

  return (
    <div className={classes.root}>
      {userDetails?.firstName && userDetails.lastName && (
        <Avatar
          name={`${userDetails.firstName} ${userDetails.lastName}`}
          className={classes.avatar}
        />
      )}
      <div className={classes.contentWrapper}>
        <div className={classes.firstDataRow}>
          <Typography variant="contentLarge" className={classes.title}>
            {isUserDataLoading ? (
              <Skeleton width={100} />
            ) : (
              userDetails?.firstName &&
              t("Hi {{firstName}}", {
                firstName: userDetails.firstName,
              })
            )}
          </Typography>
          <GroupPicker onChange={changeGroup} />
        </div>
        <AchievementData
          currentAchievements={currentAchievements}
          loading={isUserDataFetching}
        />
      </div>
    </div>
  );
};
